import React from "react";

import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';

import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import {logout} from "../services/api";
import {useNavigate} from "react-router-dom";

const BottomNavbar = () => {
    const navigate = useNavigate()
    const handleLogout = async () =>{
        try{
            await logout()
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        } catch (error){
            console.log(error)
        }

    }
    const handlePerfil = () =>{
        navigate('/perfil')
    }
    const handleInicio = () =>{
        navigate('/bienvenida')
    }
  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
      <BottomNavigation
        showLabels
      >
          <BottomNavigationAction id="nav-home" onClick={handleInicio} className={"actions active"} label="Inicio" icon={<HomeIcon />} />

          <BottomNavigationAction id="nav-user-profile" onClick={handlePerfil}  className={"actions active"} label="Perfil" icon={<PersonIcon />} />
          <BottomNavigationAction id="nav-logout" label="Logout"  onClick={handleLogout} icon={<LogoutIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavbar;